const APP_LOADING_EVENT = 'sd:app-loading';

let activeRequests = 0;

function emit() {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent(APP_LOADING_EVENT, {
    detail: {
      active: activeRequests > 0,
      count: activeRequests,
    },
  }));
}

export function startGlobalLoading() {
  activeRequests += 1;
  emit();
}

export function stopGlobalLoading() {
  activeRequests = Math.max(0, activeRequests - 1);
  emit();
}

export async function withGlobalLoader(task) {
  startGlobalLoading();
  try {
    return await task();
  } finally {
    stopGlobalLoading();
  }
}

export function subscribeGlobalLoading(callback) {
  if (typeof window === 'undefined' || typeof callback !== 'function') {
    return () => {};
  }

  const handler = (event) => callback(event.detail || { active: false, count: 0 });
  window.addEventListener(APP_LOADING_EVENT, handler);
  callback({ active: activeRequests > 0, count: activeRequests });

  return () => {
    window.removeEventListener(APP_LOADING_EVENT, handler);
  };
}
